/* eslint-disable react/display-name */
import { ComingSoonCard } from 'app/components/atoms';
import { Redirect } from 'react-router-dom';

// locals
import ProductsList from './product-management/products-list';

const ParametersConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  routes: [
    {
      path: '/product-management/products-list',
      component: ProductsList,
      title: 'Ürün Listesi - Kampanya Yönetimi ',
      isAuthProtected: true
    },
    {
      path: '/product-management',
      component: () => <Redirect to="/product-management/products-list" />
    },

    {
      path: '/parameter-management',
      component: ComingSoonCard,
      title: 'Parametre Yönetimi',
      isAuthProtected: true
    }
  ]
};

export default ParametersConfig;
